import { ChangeDetectionStrategy, Component, inject, Input, OnInit, output, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { VideoPlayerParams, VideoPlayerViewModel } from './video-player.model';
import { VideoPlayerPresenter } from './video-player.presenter';
import { JuiSkeletonLoader } from '@jump-tech-frontend/core-components-angular';
import { VideoPlayerControlsComponent } from './video-player-controls/video-player-controls.component';
import { VideoPlayerRepository } from './video-player.repository';
import { VideoRecorderService } from './video-recorder.service';

@Component({
  selector: 'question-video-player',
  templateUrl: './video-player.component.html',
  imports: [AsyncPipe, JuiSkeletonLoader, VideoPlayerControlsComponent],
  providers: [VideoPlayerPresenter, VideoPlayerRepository, VideoRecorderService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./video-player.component.scss']
})
export class VideoPlayerComponent implements OnInit {
  private readonly presenter = inject(VideoPlayerPresenter);

  public readonly vm$: BehaviorSubject<VideoPlayerViewModel | null> = new BehaviorSubject<VideoPlayerViewModel | null>({
    canDelete: false,
    showHint: true,
    canRecord: false,
    showVideo: false,
    videoSource: null,
    readOnly: true
  });

  @Input() params: VideoPlayerParams;
  public recordingUpdated = output<{ id: string; value: string | null }>();
  public loading = signal(true);

  async ngOnInit() {
    this.loading.set(true);
    await this.presenter.load(this.vm$, this.params, this.recordingUpdated);
    this.loading.set(false);
  }

  public async startRecording() {
    await this.presenter.startRecording();
  }

  public stopRecording() {
    this.presenter.stopRecording();
  }

  public pauseRecording() {
    this.presenter.pauseRecording();
  }

  public resumeRecording() {
    this.presenter.resumeRecording();
  }

  public async removeRecording() {
    await this.presenter.removeRecording();
  }
}
